<ag-grid-angular class="full-height ag-theme-vdw" [gridOptions]="gridOptions" [rowData]="rowData" [getDataPath]="getDataPath" [groupDefaultExpanded]="-1"> </ag-grid-angular>
